import {
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

export function PromptForInputModal(props: {
  onConfirm: (input: string) => void;
  onAbort: () => void;
  request: string;
  header?: string;
  suggestedInput: string;
  confirmButtonTitle?: string;
  abortButtonTitle?: string;
  colorScheme?: string;
  fileSuffix?: string;
}) {
  const [input, setInput] = useState<string | undefined>(
    props.fileSuffix
      ? cleanFileName(props.suggestedInput, props.fileSuffix)
      : props.suggestedInput
  );

  return (
    <Modal closeOnOverlayClick={true} isOpen={true} onClose={props.onAbort}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{props.header ?? "Requesting Input"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody margin={"20px"}>
          <Text fontSize={"20px"}>
            {props.request ?? "What is your input?"}
          </Text>
          <Input
            value={input}
            onChange={(event) => {
              setInput(
                props.fileSuffix
                  ? cleanFileName(event.currentTarget.value, props.fileSuffix)
                  : event.currentTarget.value
              );
            }}
          />
        </ModalBody>
        <ModalFooter borderRadius={"0px"} background={"blue.100"}>
          <HStack width={"100%"}>
            <Spacer />
            <Button
              type="button"
              paddingLeft={"40px"}
              paddingRight={"40px"}
              onClick={props.onAbort}
            >
              {props.abortButtonTitle ?? "AVBRYT"}
            </Button>
            <Button
              type="button"
              disabled={input == null && input != ""}
              onClick={() => props.onConfirm(input!)}
              colorScheme={props.colorScheme ?? "green"}
            >
              {props.confirmButtonTitle ?? "OK"}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

function cleanFileName(name: string, fileSuffix: string) {
  return `${name
    .replace(`.${fileSuffix}`, "")
    .replace(".", ",")
    .replace(/\s+/, "_")}.${fileSuffix}`;
}
